import _ from 'lodash';
import {
  createFetchActionForNamespace,
  createFetchReducersWithPagination,
  createFetchPaginatedActionForNamespace,
  createReducer,
  createFetchReducers,
  createFetchSelectors,
  noDataForAction
} from 'utils/reducers';
import {transformFiltersForStoreToFiltersForApi} from 'utils/filters';
import {transformPaginationForStoreToPaginationForApi} from 'utils/pagination';

import {PAGINATION, selectPagination} from 'ducks/pagination';
import {FILTERS, selectFilters} from 'ducks/filters';

const createFetchAction = createFetchActionForNamespace('statusPage');
const createFetchPaginatedAction = createFetchPaginatedActionForNamespace(
  'statusPage'
);

export const fetchIntegrationsStatus = createFetchPaginatedAction({
  name: 'FETCH_INTEGRATIONS_STATUS',
  initialAction: ({locationRef}, extraActions = []) => ({
    payload: {
      locationRef,
      extraActions
    }
  }),
  stateKey: 'integrations',
  defaultStateValue: [],
  extraGetParamsSelectors: [
    state =>
      transformFiltersForStoreToFiltersForApi(
        selectFilters(state, FILTERS.INTEGRATIONS_STATUS_LIST)
      ),
    state =>
      transformPaginationForStoreToPaginationForApi(
        selectPagination(state, PAGINATION.INTEGRATIONS_STATUS_LIST)
      )
  ],
  paginationNamespace: PAGINATION.INTEGRATIONS_STATUS_LIST
});
const integrationStatusSelector = createFetchSelectors(fetchIntegrationsStatus);
export const selectIntegrationsStatus = integrationStatusSelector.data;
export const selectIntegrationsIsLoading = integrationStatusSelector.isLoading;

export const selectFeatureInfo = state => {
  const filters = selectFilters(state, FILTERS.INTEGRATIONS_STATUS_LIST);
  const featureValue = _.get(filters, 'feature');
  const integrations = selectIntegrations(state);

  const selectedIntegrationInfo = _.first(
    integrations.filter(integration => integration.feature === featureValue)
  );

  return selectedIntegrationInfo;
};

export const fetchIntegrationsSetupInfo = createFetchAction({
  name: 'FETCH_INTEGRATIONS_SETUP_INFO',
  initialAction: ({locationRef}) => ({payload: {locationRef}}),
  stateKey: 'integrationsSetupInfo',
  defaultStateValue: []
});

const fetchIntegrationsSetupInfoSelector = createFetchSelectors(
  fetchIntegrationsSetupInfo
);

const selectIntegrations = fetchIntegrationsSetupInfoSelector.data;

const selectFetchIntegrationsLoading =
  fetchIntegrationsSetupInfoSelector.isLoading;

export const fetchActionReportFieldChoices = createFetchAction({
  name: 'FETCH_ACTION_REPORT_FIELD_CHOICES',
  initialAction: noDataForAction,
  stateKey: 'actionReportFieldChoices',
  defaultStateValue: {
    statusOptions: [],
    featureOptions: []
  }
});
const actionReportFieldChoicesSelector = createFetchSelectors(
  fetchActionReportFieldChoices
);
export const selectActionReportFieldChoices =
  actionReportFieldChoicesSelector.data;
export const selectFetchActionReportFieldChoicesLoading =
  actionReportFieldChoicesSelector.isLoading;

export const selectIntegrationsLoading = state =>
  selectFetchIntegrationsLoading(state) ||
  selectFetchActionReportFieldChoicesLoading(state) ||
  selectIntegrationsIsLoading(state);

const initialState = {};

const fetchActionReportFieldChoicesReducer = createFetchReducers(
  fetchActionReportFieldChoices,
  (state, action) => ({
    ...state,
    [action.parent.stateKey]: {
      isLoading: false,
      data: {
        statusOptions: action.payload.statuses,
        featureOptions: action.payload.features
      }
    }
  })
);

const fetchReducers = createReducer(initialState, {
  ...createFetchReducersWithPagination(fetchIntegrationsStatus),
  ...createFetchReducers(fetchIntegrationsSetupInfo),
  ...fetchActionReportFieldChoicesReducer
});

const reducer = (state = initialState, action) => {
  const newState = fetchReducers(state, action);

  switch (action.type) {
    default:
      return newState;
  }
};

export default reducer;
export {default as statusPageSaga} from './saga';
